module.exports = __webpack_public_path__ + "img/logo-date2022.f8968273.svg";